module.exports = __webpack_public_path__ + "img/404.ea82243f.gif";